$(".language_link").click(function(){
    let selected_lang = $(this).attr("data-value");
    setCookie("selectedLanguage",selected_lang,1);
  });

  function setCookie(cLanguage,cLangValue,cExDays){
    const d = new Date();
    d.setTime(d.getTime()+(cExDays*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cLanguage + "=" + cLangValue + ";" + expires + ";path=/";
  }

  //Reading Cookie For Selected Language
  function getCookie(cLanguage){
    let language = cLanguage + "=";
    let decodeCookie = decodeURIComponent(document.cookie);
    let ca = decodeCookie.split(";");
    for(let i=0;i < ca.length ; i++){
      let c = ca[i];
      while(c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(language) == 0){
        return c.substring(language.length, c.length);
      }
    }
    return "";
  }

  function checkCookie(current_path){
    let language = getCookie("selectedLanguage");
    if(language != ""){
      if(window.location.href.includes(language)){

      }
      else{
        window.location.href ="/"+language+current_path;
      }
    }
  }